import React from 'react';
import "./Styles/UserProfile.css";
import NavBar from '../NavBar';
import UserProfileMedicalData from './Components/UserProfileRoute/UserProfileMedicalData';
//import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import UserInfoProvider from './Components/Context/UserInfoContext';
import MedicalContextProvider from './Components/Context/MedicalContext';

function UserProfileMedicalDataRoute() {
    return (
        <UserInfoProvider>
            <MedicalContextProvider>
                <div className="UserProfileMedicalDataRoutePage">
                    <div className="UserProfileMedicalDataRouteNavBar">      
                        <NavBar/>
                    </div>
                    <div className="UserProfileMedicalDataRouteBlock">
                        <UserProfileMedicalData/>
                    </div>
                </div>
            </MedicalContextProvider>
       </UserInfoProvider>
    );
}

export default UserProfileMedicalDataRoute;